module.exports = __webpack_public_path__ + "static/media/6.5-events.6baf5303.jpg";